import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class GerminatingSeeds extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_seeds.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Germinating Seeds
        </h2>
        <p>
        <span className="highlight">Timeline: 1 - 2 Days</span>
        </p>
        <p>
        So you’re ready to plant your first marijuana seed. Planting it directly into the soil will work, however you’ll greatly improve your odds of success if you germinate the seed first. 
        </p>
        <h3>Method #1</h3>
        <p>
        Our recommended method of germinating seeds is to wet a paper towel, fold it in half, and place your seeds in the middle. Then leave the paper towel in a warm, dark place. You’ll know your seed is germinated when it splits in two and a white taproot emerges. This can take around a day or two to happen. Be careful when transporting your sprouted seed to soil. Don’t touch the taproot with your hands, tweezers are a good idea to carefully move the seed. Every time you transplant a sprouted seed, it can cause stress as the young plant needs to readjust its new surroundings.
        </p>
        <h3>Method #2</h3>
        <p>
        If you’re starting from an older seed you can try an alternate method more suited to waking up old seeds. Soak your seeds in a shotglass of slightly warm water overnight. Don’t leave them in the water for more than 24 hours (they can drown). After this place any still ungerminated seeds in a warm, moist place to finish germinating.
        </p>
        <GuideButton slugTo="seedlings" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/two_germinating_seeds.js